import { media } from "./media";
import { metaInformation } from "./metaInformation";
import { KontentFilterable } from "./filterable";
import { richText } from "./richText";
import { ctas } from "./ctas";
import { sectionMetaData } from "./GeneralPage/generalSection";

export type feature = {
  title: string;
  body: richText;
  layout: "left" | "right" | "center";
  asset: media;
  cta: ctas;
} & metaInformation<"feature"> &
  sectionMetaData &
  KontentFilterable;

export function isFeature(item: any): item is feature {
  return item?.type === "feature";
}
